import { render, staticRenderFns } from "./UserDashboardProducts.vue?vue&type=template&id=00c288e7&scoped=true"
import script from "./UserDashboardProducts.vue?vue&type=script&lang=js"
export * from "./UserDashboardProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c288e7",
  null
  
)

export default component.exports